module.exports = __webpack_public_path__ + "static/media/orange-lasso.0908a70f.png";